import { CheckCircle } from '@phosphor-icons/react';
import { OAuthStatus } from 'src/utils/integrationUtils';

interface OAuthStatusViewProps {
  status: OAuthStatus;
  existingConnection: boolean;
}

export const OAuthStatusView = ({
  status,
  existingConnection,
}: OAuthStatusViewProps) => {
  if (status === OAuthStatus.Waiting) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <div className="text-neutral-600 mb-4">
          {existingConnection
            ? 'A popup window should open. Please complete authentication there, then click Refresh to verify the connection.'
            : 'A popup window should open, please proceed there'}
        </div>
      </div>
    );
  }

  if (status === OAuthStatus.Closed) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <div className="text-neutral-600 mb-4">
          The connection window was closed. If you completed authentication in
          the other window, please click Refresh again to verify.
        </div>
      </div>
    );
  }

  if (status === OAuthStatus.Success) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <CheckCircle
          className="h-16 w-16 text-success-500 mb-4"
          weight="fill"
        />
        <h3 className="text-lg font-semibold text-neutral-700 mb-2">
          Connection established successfully
        </h3>
      </div>
    );
  }

  return null;
};
